window.humblerSetAtcLoading = window.humblerSetAtcLoading || ((button, isLoading) => {
  if (!button) return;

  const spinner = button.querySelector('.loading-overlay__spinner');

  button.classList.toggle('loading', isLoading);
  button.classList.toggle('humbler-atc-loading', isLoading);
  if (isLoading) {
    button.setAttribute('data-humbler-loading', 'true');
  } else {
    button.removeAttribute('data-humbler-loading');
  }

  if (spinner) {
    spinner.classList.add('hidden');
    spinner.setAttribute('aria-hidden', 'true');
  }
});

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    async onSubmitHandler(evt) {
      if (evt.defaultPrevented) return;
      evt.preventDefault();
      if (this.isSubmitting || this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.isSubmitting = true;
      this.error = false;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', 'true');
      window.humblerSetAtcLoading(this.submitButton, true);
      let addedToCart = false;
      let formData;

      try {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        formData = this.form ? new FormData(this.form) : new FormData();
        if (!this.form) formData.append('id', this.querySelector('[name=id]').value);
        if (this.cart && !window.customCart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        const response = await fetch(routes.cart_add_url, config);
        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || window.cartStrings.error);
        }
        addedToCart = true;
        const quickAddModal = this.closest('quick-add-modal');
        if (window.customCart) {
          quickAddModal?.hide(true);
          await window.customCart.update();
        } else if (this.cart) {
          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => this.cart.renderContents(data), {once: true});
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(data);
          }
        } else {
          window.location.assign(window.routes.cart_url);
        }
      } catch (error) {
        if (addedToCart) {
          window.location.assign(window.routes.cart_url);
        } else {
          const message = error.message || window.cartStrings.error;
          this.handleErrorMessage(message);
          publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData?.get('id'), errors: message, message});
        }
      } finally {
        this.isSubmitting = false;
        window.humblerSetAtcLoading(this.submitButton, false);
        this.submitButton.removeAttribute('aria-disabled');
        if (this.cart && addedToCart) this.cart.classList.remove('is-empty');
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

